import { LD, useLDFlag } from '@dutchie-pos/utils';

import {
  getGoodCannaStatusString,
  GOODCANNA_STATUS_DENIED,
  GOODCANNA_STATUS_PENDING,
} from 'src/utils/helpers/goodcanna-status';

/**
 * GoodCanna status for med certification checkout blocking (parity with register).
 */
export const useGoodCannaStatus = (goodCannaStatus?: number | null) => {
  const isGoodCannaIntegrationRolloutEnabled = useLDFlag(LD.FINTECH_RETAIL_PAYMENTS_USE_GOODCANNA_INTEGRATION_ROLLOUT, false);
  const normalizedStatus = getGoodCannaStatusString(goodCannaStatus ?? undefined);
  const showMedCertificationBanner =
    isGoodCannaIntegrationRolloutEnabled &&
    (normalizedStatus === GOODCANNA_STATUS_PENDING || normalizedStatus === GOODCANNA_STATUS_DENIED);

  const medSelectCartPillLabel = showMedCertificationBanner
    ? normalizedStatus === GOODCANNA_STATUS_DENIED
      ? 'Med denied'
      : 'Med pending'
    : null;

  return {
    isGoodCannaIntegrationRolloutEnabled,
    goodCannaStatus: normalizedStatus,
    medSelectCartPillLabel,
    showMedCertificationBanner,
  };
};
